import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[80vh] flex flex-col items-center justify-center px-4 py-16 overflow-hidden bg-navy-900" data-id="element-100">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-101"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-102">
        <FadeIn delay={0.1} data-id="element-103">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-8 text-cream-100" data-id="element-104">
            "La Técnica Que Ven Todos Tus Pacientes Pero Que Pocos Terapeutas
            Saben Aplicar Con Precisión Real"
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-105">
          <h2 className="text-xl md:text-2xl text-gold-400 font-body font-light leading-relaxed mb-12 max-w-3xl mx-auto" data-id="element-106">
            Descubre el sistema completo que transforma una simple tira de cinta
            en una herramienta clínica de precisión — con protocolos listos para
            aplicar desde hoy mismo, sin importar tu nivel actual
          </h2>
        </FadeIn>

        <FadeIn delay={0.45} className="relative max-w-3xl mx-auto mb-14" data-id="element-107">
          <div className="absolute inset-0 bg-gold-500/10 blur-[80px] rounded-full transform scale-75" data-id="element-108"></div>
          <img src="https://cdn.magicpatterns.com/uploads/cLFGdMaCnxvMQXQcyvBKGG/mock_up_V2.png" alt="Kinesiotaping Clínico Pro - Edición Digital Premium" className="relative z-10 w-full h-auto drop-shadow-[0_20px_40px_rgba(0,0,0,0.4)]" data-id="element-109" />
        </FadeIn>

        <FadeIn delay={0.5} className="space-y-6 text-lg md:text-xl text-cream-200/90 mb-12 max-w-2xl mx-auto italic font-light" data-id="element-110">
          <p data-id="element-111">
            ¿Cuántas veces has visto la cinta de colores en un deportista, en un
            paciente, en televisión... y no has podido explicar con exactitud
            por qué funciona?
          </p>
          <p data-id="element-112">
            ¿Cuántas veces has aplicado Kinesiotaping siguiendo un video de
            YouTube, sin saber si la tensión era correcta, si la dirección era
            la adecuada, si realmente estabas ayudando a tu paciente?
          </p>
          <p className="text-gold-500 font-semibold not-italic text-2xl mt-8" data-id="element-113">
            Eso termina hoy.
          </p>
        </FadeIn>

        <FadeIn delay={0.7} data-id="element-114">
          <CTAButton text="QUIERO DOMINAR ESTA TÉCNICA" href="#pricing" className="mt-4" data-id="element-115" />
        </FadeIn>
      </div>
    </section>;
}